import React from 'react';

const ManualIndex = ({ sections, onSelect, currentSlug, isLoading, error, emptyMessage }) => {
  if (isLoading) {
    return <div className="manual-index__state">Cargando índice…</div>;
  }

  if (error) {
    return <div className="manual-index__state manual-index__state--error">{error}</div>;
  }

  if (!sections || sections.length === 0) {
    return <div className="manual-index__state">{emptyMessage || 'No hay secciones disponibles.'}</div>;
  }

  const handleSelect = (slug) => {
    if (slug) {
      onSelect(slug);
    }
  };

  const renderSections = (items, level = 0) => (
    <ul className={`manual-index__list manual-index__list--level-${level}`}>
      {items.map((section) => {
        const sectionSlug = section.slug || section.path;
        const isActive = sectionSlug && currentSlug === sectionSlug.replace(/^\/+/, '');
        const hasChildren = Array.isArray(section.children) && section.children.length > 0;

        return (
          <li key={sectionSlug || section.title} className="manual-index__item">
            <button
              type="button"
              onClick={() => handleSelect(sectionSlug)}
              className={`manual-index__link${isActive ? ' manual-index__link--active' : ''}`}
            >
              <span className="manual-index__link-title">{section.title}</span>
              {section.summary && <span className="manual-index__link-summary">{section.summary}</span>}
            </button>
            {hasChildren && (
              <div className="manual-index__children">
                {renderSections(section.children, level + 1)}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );

  return (
    <nav className="manual-index" aria-label="Índice del manual">
      {renderSections(sections)}
    </nav>
  );
};

export default ManualIndex;

